import { render, staticRenderFns } from "./DeliveryListCompletedPage.vue?vue&type=template&id=490084a0&scoped=true&"
import script from "./DeliveryListCompletedPage.vue?vue&type=script&lang=js&"
export * from "./DeliveryListCompletedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490084a0",
  null
  
)

export default component.exports